import { match } from 'ts-pattern'
import type { JobTriggerMutator } from '@/lib/entity/job_trigger'
import type { Converter } from '@/lib/converter/entityFormatter'
import { asModifiedField } from '@/lib/converter/entityFormatter'

type JobTriggerSchema = JobTriggerMutator['merged']

export const JobTriggerConverter: Converter<JobTriggerSchema> = {
  icon: () => 'schedule',
  title: () => 'ジョブトリガー',
  subTitle: async (merged) => merged.job_id ?? '入力中...',
  modifiedFields: (modified, column) => {
    const labelMap: Record<string, string> = {
      job_id: 'ジョブID',
      trigger_type: 'トリガータイプ',
      params: 'パラメータ',
      claim: 'クレーム',
      timing: 'タイミング'
    }

    const label = labelMap[column as string]
    if (!label) return undefined

    return match(column)
      .with('job_id', 'trigger_type', 'params', 'claim', 'timing', (column) =>
        asModifiedField(label, modified[column] ?? '')
      )
      .with('id', () => undefined)
      .otherwise(() => undefined)
  }
}
